<div class="error-image">
  <img
    [src]="
      globalErrorType() === 'conversation-not-found'
        ? '/assets/images/conversation-not-found.svg'
        : '/assets/images/general-error.svg'
    "
    [attr.alt]="computedTitle() | translate" />
</div>
<div
  class="error-content"
  #dialogContent
  role="alertdialog"
  [attr.aria-modal]="true"
  [attr.aria-labelledby]="titleId"
  [attr.aria-describedby]="messageId"
  tabindex="-1"
  [attr.data-testid]="testId()">
  <h1 [id]="titleId" data-testid="global-error-title">
    {{ computedTitle() | translate }}
  </h1>
  <p [id]="messageId" data-testid="global-error-message">{{ message() | translate }}</p>
  @if (hasReload()) {
    <orbit-button
      data-testid="global-error-reload-button"
      (click)="reload.emit()"
      (keydown)="onReloadKeyDown($event)"
      [label]="'SHARED.ERRORS.GLOBAL.RELOAD' | translate"
      [icon]="refreshIcon"
      [size]="'large'" />
  }
</div>
